var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationComment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#2C91D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6004_51755",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9004 4.8999L5.90039 4.8999C5.35039 4.8999 4.90039 5.3499 4.90039 5.8999L4.90039 14.8999L6.90039 12.8999L13.9004 12.8999C14.4504 12.8999 14.9004 12.4499 14.9004 11.8999L14.9004 5.8999C14.9004 5.3499 14.4504 4.8999 13.9004 4.8999ZM12.9004 10.8999L6.90039 10.8999L6.90039 9.8999L12.9004 9.8999L12.9004 10.8999ZM6.90039 9.3999L12.9004 9.3999V8.3999L6.90039 8.3999V9.3999ZM12.9004 7.8999L6.90039 7.8999L6.90039 6.8999L12.9004 6.8999V7.8999Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6004_51755)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "matrix(-1 0 0 1 15.9004 3.8999)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationComment);
export default __webpack_public_path__ + "static/media/icNotificationComment.7b59385fe14488aba21f641b9ced48d4.svg";
export { ForwardRef as ReactComponent };